/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Events.AlarmChannes <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 22.1.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 22.1.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.AlarmChannels", $.common.VisualBase, {
  
    signalList: null,
    dirty: false,

    _create: function () {
        var me = this;

        try {

            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 307;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {
           
            me.showMessage("", false);

            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.fnd("#div-top-menu").height() -
                me.fnd(".vc-list-header").height());
            me.fnd(".vc-list-table").height(h - 28);
          
            //get our stuff
            me._fetch();

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
          
            me.element.on("click", " #btn-sort", function () { me._sort();});
            me.element.on("click", " #btn-save", function () { me._save() });
            me.fnd("#btn-save").button();
            me.fnd(" #btn-save").button("option", "disabled", true);


            //input validation for input field
            me.fnd(".vc-list-table", '.txt').keyup(function (e) {
                me._validate($(e.target));
            });
            me.fnd(".vc-list-table", '.ddl').change(function (e) {
                me._validate($(e.target));
            });

            //click handler for the del and add buttons
            me.fnd(".vc-list-table").on("click", '.btn-del', function (e) {
                $(e.target).parents(".vc-list-item").removeClass("dirty delete add").addClass("dirty delete");
                $(e.target).parents(".vc-list-item").data("active", false);
                $(e.target).parents(".vc-list-item").addClass("delete");
                $(e.target).parents(".vc-list-item").find(".col2").hide();
                $(e.target).parents(".vc-list-item").find(".col3").hide();
                $(e.target).parents(".vc-list-item").find(".div-btn-add").show();
                me._setDirty(true);
            });

            me.fnd(".vc-list-table").on("click", '.btn-add', function (e) {
                $(e.target).parents(".vc-list-item").removeClass("dirty delete add").addClass("dirty add");
                $(e.target).parents(".vc-list-item").data("active", true);
                $(e.target).parents(".vc-list-item").find(".col2").show();
                $(e.target).parents(".vc-list-item").find(".col3").show();
                $(e.target).parents(".vc-list-item").find(".div-btn-add").hide();
                me._setDirty(true);
            });


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },


    _validate: function (obj) {
        var me = this;
        try {

           
            var val = obj.val().trim();
            var bInvalid = false;
            if (val.indexOf(",") > -1 || val.indexOf(".") > -1) {
                bInvalid = true;
            }

            if (val.length === 0) {
                bInvalid = true;
            } else {
                if ((validateNumeric(val) === false || isNaN(parseFloat(val)))) {
                    bInvalid = true;
                }
            }
            if (val.indexOf(",") > -1) {
                bInvalid = true;
            }
            if (bInvalid) {
                obj.removeClass("error ").addClass("error");
                me._setDirty(false);
            } else {
                obj.removeClass("error");
                me._setDirty(true);
            }
            obj.removeClass("dirty").addClass("dirty");
            obj.parents(".vc-list-item").removeClass("dirty").addClass("dirty");
           


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {


            //first we must preventively handle the sort button
            me.fnd("#btn-sort").removeClass("button-toggle-active");
            if (me.fnd(".vc-list-table").sortable("instance") !== undefined) {
                me.fnd(".vc-list-table").sortable("destroy");
            }
            
            me.fnd(".vc-list-table").html(me.getLoadingIcon());

            me.getData( "", function (result) {
                //check response content
                if (result === null) {
                    me.signalList = null;
                } else {
                    me.signalList = result;
                }
                me._setDirty(false);
                me._generateSignalList();
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },



    _generateSignalList: function () {
        /// <summary>
        /// This function generates a list from the data and ...
        /// shows/hides the entries for active and not active entries
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item, col, col1;
        var list;
        var name;
        try {

            list = me.fnd(".vc-list-table");
            list.html("");

            if (me.signalList === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            if (me.signalList.length===0) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }


            var ddlSignals =  $("<select>", { class: "bsaid txtEnabled" });
            var index = 0;
            //for (var val of vals) {
            ddlSignals.append($("<option>").prop('value', 1).text(1));
            
            //}


            //console.info(me.signalList);

            for (var i = 0; i < me.signalList.length; i++) {
                item = $("<div>", { "class": "vc-list-item", "data-id": me.signalList[i].ID, "data-active": me.signalList[i].Active });
                col = $("<div>", { "class": "vc-list-col col1" });

                name = me.signalList[i].Name;


                if (me.signalList[i].InUse === false) {
                    if (me.signalList[i].LastState) {
                        name = "<i class='fa-regular fa-check-circle icon-color-ok vc-grid-margin-right' title='on'></i>" +
                            name;
                    } else {
                        name = "<i class='fa fa-minus-circle icon-color-warning vc-grid-margin-right' title='off'></i>" +
                            name;
                    }


                    col.append($("<div>", { "class": "vc-list-col-element", "html": name }));
                    col.append($("<div>", { "class": "vc-list-col-element icons div-btn-add w5", "html": $("<div>", { "class": "btn-add", html: $("<i>", { "class": "fa fa-plus icon-color-ok" }) }) }));
                } else {
                    col.append($("<div>", { "class": "vc-list-col-element inUse", "html": me.signalList[i].Name + " <span style='font-size:smaller'>(" + me.specific.resources.alreadyInUse_lbl + ")</span>" }));
                }
                item.append(col);

                col1 = $("<div>", { "class": "vc-list-col col2" });
                col1.append($("<div>", { "class": "vc-list-col-element div-timer", "html": $("<div>", { "class": " timerx", html: me.signalList[i].Timer }) }));
                item.append(col1);
                var col3 = $("<div>", { "class": "vc-list-col col3" });

                var css = "vc-list-col-element col31 " + (me.signalList[i].UseBsaid ? "" : " hide ");
               
                col3.append($("<div>", { "class": css + " ddl", "html": me.fnd(".ddl-signal-template .select-signals").clone().val(me.signalList[i].UseBsaid ? me.signalList[i].Bsaid  : -1) }));
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled minpower", value: me.signalList[i].UseBsaid ? me.signalList[i].MinPower : 0 }) }));
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled maxpower", value: me.signalList[i].UseBsaid ? me.signalList[i].MaxPower : 0 }) }));
                col3.append($("<span class='col31" + (me.signalList[i].UseBsaid ? "" : " hide ") + "' style='float:left;margin-left:6px'>").html("|"));
                
                if (!me.signalList[i].UseBsaid)  col3.append($("<span class='col31 spacer' style='float:left;'>").html("<br/>"));

                css = "vc-list-col-element col41 ";
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled power", value: me.signalList[i].Power }) }));
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled min-on", value: me.signalList[i].MinOn }) }));
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled min-off", value: me.signalList[i].MinOff }) }));
                col3.append($("<div>", { "class": css + " txt", "html": $("<input>", { "class": "txtEnabled max-off", value: me.signalList[i].MaxOff }) }));
                col3.append($("<div>", { "class": "vc-list-col-element icons div-btn-del w3", "html": $("<div>", { "class": "btn-del", html: $("<i>", { "class": "fa fa-times icon-color-error" }) }) }));
                item.append(col3);

                list.append(item);
            }
            //now, we hide the second col for inactive entries
            me.fnd('.vc-list-table .vc-list-item').each(function () {
                if ($(this).data("active") === false) {
                    $(this).find(".col2").hide();
                    $(this).find(".col3").hide();
                } else {
                    $(this).find(".div-btn-add").hide();
                }
            });
         
            me.fnd('.vc-list-table .vc-list-item:even').addClass('alt');


            me.fnd('.vc-list-table .minon').attr("title", me.specific.resources.minOnTime).tipTip();
            me.fnd('.vc-list-table .minoff').attr("title", me.specific.resources.minOffTime).tipTip();
            me.fnd('.vc-list-table .maxoff').attr("title", me.specific.resources.maxOffTime).tipTip();

            //we activate the clock timer and are done
            var w = parseInt(me.fnd(".div-timer").width());
            me.fnd(".timerx").vcClockTimer({
                width: w, height: 22, twoLine: false, multiState: (me.specific.startType ===1), showLegend: false, callback: function (e) {
                    $(e.element).parents(".vc-list-item").removeClass("dirty").addClass("dirty");
                    me._setDirty(true);
                }
            });

            me._setDirty(false);

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },


    _save: function () {
        /// <summary>
        /// This function sends the update request - quite simple
        /// </summary>
        var me = this;
        var data = [];
        var param;
        var item;
        try {
          
            if (me.fnd(".vc-list-table .error").length > 0) {
                me.openInfoDialog(me.specific.resources.ERR_inputInvalid_lbl, { at: 'center center-20%', of: window }); return false;
            }

            me.fnd(".vc-list-table .vc-list-item").each(function () {
                if ($(this).data("active")) {

                    //console.info($(this).find(".bsaid").val());


                    item = {
                        "ID": $(this).data("id"),
                        "Timer": $(this).find(".timerx").html(),
                        "MinOn": $(this).find(".min-on").val(),
                        "MinOff": $(this).find(".min-off").val(),
                        "MaxOff": $(this).find(".max-off").val(),
                        "Power": $(this).find(".power").val(),
                        "Bsaid": $(this).find(".bsaid").val(),
                        "MinPower": $(this).find(".minpower").val(),
                        "MaxPower": $(this).find(".maxpower").val()
                    }
                    data.push(item);
                }
            });
         
           // if (data.length === 0) { return true; }

            param = { "data": data }
            me.updateData(param, function (result) {

                if (result === true) {

                    _VCMQ.produce(me.visual, me.vcgid, 'EVENT_CONFIG_DIRTY', "");

                    me._fetch();
                } else {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },


    _setDirty: function (bDirty) {
        /// <summary>
        /// This function activates/deactivates the save button with a bit of data validation
        /// </summary>
        var me = this;
        try {

            me.dirty = bDirty;
            me.fnd('.vc-list-item').each(function() {
                if ($(this).data("active") === true && $(this).find(".error").length > 0) {
                    me.fnd(" #btn-save").button("option", "disabled", true);
                    return true;
                }
// ReSharper disable once NotAllPathsReturnValue
            });
            me.fnd(" #btn-save").button("option", "disabled", !me.dirty);

            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    },


    _sort: function () {
        /// <summary>
        /// This function activates/deactivates the sorting 
        /// </summary>
        var me = this;
        try {
            if (me.fnd("#btn-sort").hasClass("button-toggle-active")) {
                me.fnd(".vc-list-item .btn-del").show();
                me.fnd(".vc-list-item .div-sorting").show();
                me.fnd(".vc-list-item").show();
                me.fnd(".vc-list-table").sortable("destroy");
                me.fnd("#btn-sort").removeClass("button-toggle-active");
            } else {
                me.fnd(".vc-list-item .btn-del").hide();
                me.fnd(".vc-list-item").addClass("sorting");
                me.fnd('.vc-list-item').each(function () {
                    if ($(this).data("active") === false) {
                        $(this).hide();
                    }
                });
                //make a sortable list out of the list
                me.fnd(".vc-list-table").sortable({
                    placeholder: 'formSortPlaceholder', forcePlaceholderSize: true, helper: 'clone',
                    update: function () { me._setDirty(true); }
                }).disableSelection();
                me.fnd("#btn-sort").addClass("button-toggle-active");
            }
            return true;
        } catch (e) {
            me.writeError('_sort', e); return false;
        }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd(".lst-signals, #btn-save").hide();
            }
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});










//TODO: delete after migrating old Spitzenlast
$.widget("bluaul.AlarmChannelsV1", $.common.VisualBase, {
    vcChart: null,
    bInit: false,
    bsaid:-1,
    signalList: null,
    dirty: false,
    saved: false,
    myChart: null,
    _create: function() {
        /**sets global values and inital values
         *
         */
        var me = this;

        try {
            // set the Visual-Name first
            me.options.invoke.vcvid = 306;

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function() {
        var me = this;
        try {

            me.showMessage("", false);

            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
           me.visual.find("#div-top-menu").height() -
            me.visual.find(".vc-list-header").height());
            me.visual.find(".vc-list-table").height(h - 28);
         
            me._fetch();

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },
    
    _initEvents: function() {
        var me = this;
        try {
        


            me.element.on("click", " #btn-save", function () { me._save() });
            me.visual.find("#btn-save").button();


            //input validation for input field
            me.visual.find(".vc-list-table", '.validate').keyup(function(e) {
                console.info($(e.target).val());
                var val = $(e.target).val().replace('.', '').trim();
                var bInvalid = false;
                if (val.length === 0) {
                    bInvalid = true;
                } else {
                    if ((validateNumeric(val) === false || isNaN(parseFloat(val)))) {
                        bInvalid = true;
                    }
                }
                if (bInvalid) {
                    $(e.target).removeClass("error ").addClass("error");
                } else {
                    $(e.target).removeClass("error");
                }
                $(e.target).removeClass("dirty").addClass("dirty");
                $(e.target).parents(".vc-list-item").removeClass("dirty").addClass("dirty");
            });

            me.visual.find(".vc-list-table").on("click", '.btn-del', function (e) {
                $(e.target).parents(".vc-list-item").removeClass("dirty delete add").addClass("dirty delete");
                $(e.target).parents(".vc-list-item").addClass("delete");
                $(e.target).parents(".vc-list-item").find(".col2").hide();
                $(e.target).parents(".vc-list-item").find(".div-btn-add").show();
            });

            me.visual.find(".vc-list-table").on("click", '.btn-add', function (e) {
                $(e.target).parents(".vc-list-item").removeClass("dirty delete add").addClass("dirty add");
                $(e.target).parents(".vc-list-item").find(".col2").show();
                $(e.target).parents(".vc-list-item").find(".div-btn-add").hide();
            });


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        var param;
        try {

            me.visual.find(".vc-list-table").html(me.getLoadingIcon());
            //set param for ajax request
            param = {
                Type:1
            };
        
            me.getData(param, function (result) {
                //check response content
                //me.valueList = null;
                if (result === null) {
                    me.signalList = null;
                } else {

                    me.signalList = result;
                }

                //me._setDirty(false);
                me._generateSignalList();
              
                return true;
            });

        } catch (e) {
            me.writeError('_fetch', e); return false;
        }
        return true;
    },



    _generateSignalList: function () {
        /// <summary>
        /// This function sends the update request - quite simple
        /// </summary>
        var me = this;
        var data;
        var param;
        var item, col, col1;
        var list;
        var tmp;
        var del;
        try {

          //  if (me.bsaid === -1) { return true; }

            del = $("<div>", { "class": "btn-add", html: $("<i>", { "class": "fa fa-times vc-icon-color-error" }) });
           

            list = me.visual.find(".vc-list-table");
            list.html("");
            var name;
            for (var i = 0; i < me.signalList.length; i++) {
                item = $("<div>", { "class": "vc-list-item", "data-id": me.signalList[i].ID, "data-alertid": me.signalList[i].AlertID });
                col = $("<div>", { "class": "vc-list-col col1" });
                name = $("<div>", { "class": "vc-list-col-element" });
                if (me.signalList[i].LastState) {
                    name.append($("<i>", { "class": "fa-regular fa-check-circle icon-color-ok vc-grid-margin-right", "title": "on" }));
                } else {
                    name.append($("<i>", { "class": "fa fa-minus-circle icon-color-warning vc-grid-margin-right", "title": "off" }));
                }
               
                name.append(  me.signalList[i].Name);
                col.append($("<div>", { "class": "vc-list-col-element", "html": name }));

                col.append($("<div>", { "class": "vc-list-col-element icons div-btn-add w5", "html": $("<div>", { "class": "btn-add", html: $("<i>", { "class": "fa fa-plus icon-color-ok" }) }) }));
                
                item.append(col);
                col1 = $("<div>", { "class": "vc-list-col col2" });
                col1.append($("<div>", { "class": "vc-list-col-element div-timer", "html": $("<div>", {  "class": " timerx", html: me.signalList[i].Timer }) }));
                col1.append($("<div>", { "class": "vc-list-col-element txt w8", "html": $("<input>", { "class": "txtEnabled min-on", value: me.signalList[i].MinOn}) }));
                col1.append($("<div>", { "class": "vc-list-col-element txt w8", "html": $("<input>", { "class": "txtEnabled min-off", value: me.signalList[i].MinOff }) }));
                col1.append($("<div>", { "class": "vc-list-col-element txt w8", "html": $("<input>", { "class": "txtEnabled max-off", value: me.signalList[i].MaxOff }) }));

                col1.append($("<div>", { "class": "vc-list-col-element icons div-btn-del w5", "html": $("<div>", { "class": "btn-del", html: $("<i>", { "class": "fa fa-times icon-color-error" }) }) }));

                item.append(col1);
                //item.append("<i  class='vc-list-icon popup fa fa-info-circle color-font-secondary' title='" + me.resources.signalInfo + "'></i>");
                //store the first item for later
               
                list.append(item);
            }

            me.visual.find('.vc-list-table .vc-list-item').each(function() {
                if ($(this).data("alertid") === -1) {
                    $(this).find(".col2").hide();
                } else {
                    $(this).find(".div-btn-add").hide();
                }
            });

            me.visual.find('.vc-list-table .vc-list-item:even').addClass('alt');


            var w = parseInt(me.visual.find(".div-timer").width());
            me.visual.find(".timerx").vcClockTimer({
                width: w, height: 22, twoLine: false, thirtyMin: true, multiState: true, showLegend: false, callback: function(e) {
                    $(e.element).parents(".vc-list-item").removeClass("dirty").addClass("dirty");
                }});


            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },

    
    _save: function () {
        /// <summary>
        /// This function sends the update request - quite simple
        /// </summary>
        var me = this;
        var data = [];
        var param;
        var item;
        try {


            if (me.visual.find(".vc-list-table .error").length > 0) {
              
                me.openInfoDialog(me.specific.resources.ERR_inputInvalid_lbl, { at: 'center center-20%', of: window }); return false;
                
            } 

            me.visual.find(".vc-list-table .vc-list-item.dirty").each(function () {

                item = {
                    "ID": $(this).data("id"),
                    "AlertID": $(this).data("alertid"),
                    "Timer": $(this).find(".timerx").html(),
                    "MinOn": $(this).find(".min-on").val(),
                    "MinOff": $(this).find(".min-off").val(),
                    "MaxOff": $(this).find(".max-off").val()

                }
                if ($(this).hasClass("add")) {
                    item.DataType = 1;
                }
                if ($(this).hasClass("delete")) {
                    item.DataType = 2;
                }
                data.push(item);

            });
            if (data.length === 0) {
            
                return true;
            }
            param = { "data": data}



            me.updateData(param, function (result) {

                if (result === true) {
                    
                    me._fetch();
                } else {

                    me.showMessage(me.resources.err_saveData, true);
                  //  me.visual.find(".lst-signals").html($("<div>").addClass("error").html(me.resources.err_saveData));
                }
           
                return true;
            });

            return true;
        } catch (e) {

            me.writeError('_save', e); return false;
        }

    },


    _setDirty: function (bDirty) {
        var me = this;
        try {
         
            me.dirty = bDirty;
            if (!bDirty) { me.saved = false; }

            if (me.visual.find(".lst-values .txtEnabled.error").length > 0) {
                me.visual.find(" #btn-save").button("option", "disabled", true);
                return true;
            }

            me.visual.find(" #btn-save").button("option", "disabled", !me.dirty);

            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    },

    specificInfoHandling: function(bError) {
        var me = this;
        try {
            if (bError) {
                me.visual.find(".lst-signals, #btn-save, #btn-sort").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});
